/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlResolutionRequestUser
 */
export interface ControlResolutionRequestUser {
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestUser
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestUser
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestUser
     */
    org_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestUser
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestUser
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestUser
     */
    last_name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlResolutionRequestUser
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestUser
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestUser
     */
    updated: string;
}

/**
 * Check if a given object implements the ControlResolutionRequestUser interface.
 */
export function instanceOfControlResolutionRequestUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;

    return isInstance;
}

export function ControlResolutionRequestUserFromJSON(json: any): ControlResolutionRequestUser {
    return ControlResolutionRequestUserFromJSONTyped(json, false);
}

export function ControlResolutionRequestUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlResolutionRequestUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'user_id': json['user_id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'active': json['active'],
        'created': json['created'],
        'updated': json['updated'],
    };
}

export function ControlResolutionRequestUserToJSON(value?: ControlResolutionRequestUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'client_id': value.client_id,
        'org_id': value.org_id,
        'user_id': value.user_id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'active': value.active,
        'created': value.created,
        'updated': value.updated,
    };
}

